module.exports = __webpack_public_path__ + "static/media/girl_makeup.6482f10b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand/girl_makeup.png
// module id = 158
// module chunks = 0